import { Switch } from '@cian/ui-kit';
import { IconActionClose12 } from '@cian/ui-kit-design-tokens/icons';
import * as React from 'react';

import { FrequencyContainer } from './FrequencyContainer';
import * as styles from './styles/subscription.css';
import { EType } from '../../../../../repositories/subscriptions/entities/schemas/GetSubscriptionsResponseSchema';
import { trackingPageType, trackSubscriptionDelete, trackSubscriptionToggle } from '../../../../../tracking';
import { getToggleLabel, serializeDeviceType, serializeLabel } from '../../../../../utils/tracking';
import { SubscriptionContent } from '../../../../base/SubscriptionContent';

import type { TDeviceType } from '../../../../../store';
import type { ISubscriptionIsActiveParams, ISubscriptionsDeletedParams } from '../../../../../store/subscriptions';
import type { TFrequenciesList } from '../../SubscriptionsSection';

export interface ISubscriptionStoreProps {
  deviceType: TDeviceType;
  token: string | null;
}

export interface ISubscriptionDispatchProps {
  deleteSubscriptionItem(params: ISubscriptionsDeletedParams): void;
  onChange(params: ISubscriptionIsActiveParams): void;
}

export interface ISubscriptionOwnProps {
  /** Пропы основного контента подписки */
  categoryName: string;
  itemId: number;
  title: string;
  subtitle: string;
  /** Пропы дополнительного контента подписки (частота рассылок) */
  frequency?: string;
  frequenciesList: TFrequenciesList | null;
  /** Пропы экшена подписки (тоггл или что-то ещё) */
  type: EType;
  isActive: boolean;
  /** Url для перехода в подписку - например: сохраненный поиск */
  url?: string;
}

export type ISubscriptionProps = ISubscriptionStoreProps & ISubscriptionDispatchProps & ISubscriptionOwnProps;

export class Subscription extends React.Component<ISubscriptionProps, {}> {
  public render() {
    const { title, subtitle, url } = this.props;

    return (
      <div className={styles['subscription']}>
        <div className={styles['main_content']} data-testid="SubscriptionMainContent">
          <SubscriptionContent title={title} subtitle={subtitle} url={url} />

          <div className={styles['action']} data-testid="Action">
            {this.getAction()}
          </div>
        </div>

        <div className={styles['addition_content']} data-testid="SubscriptionAdditionContent">
          {this.getAdditionContent()}
        </div>
      </div>
    );
  }

  private deleteSubscription = () => {
    const { deleteSubscriptionItem, categoryName, itemId } = this.props;

    deleteSubscriptionItem({
      categoryName,
      itemId,
    });
  };

  private getAction = () => {
    const { isActive, type, itemId, categoryName } = this.props;
    const toggleParams = {
      categoryName,
      itemId,
      prevIsActive: isActive,
    };

    switch (type) {
      case EType.Toggle:
        return (
          <Switch defaultChecked={isActive} onChange={() => this.onToggleClick(toggleParams)} data-name="Switch" />
        );

      case EType.Delete:
        return (
          <span onClick={this.onDeleteClick} data-name="Close">
            <IconActionClose12 />
          </span>
        );

      default:
        return '';
    }
  };

  private getAdditionContent = () => {
    const { frequenciesList, frequency, itemId, categoryName, isActive } = this.props;

    if (frequenciesList && frequenciesList.length > 0) {
      return (
        <div className={styles['addition_content_item']} data-testid="AdditionContent">
          <FrequencyContainer
            itemId={itemId}
            isEnabled={isActive}
            options={frequenciesList}
            selectedValue={frequency}
            categoryName={categoryName}
          />
        </div>
      );
    }

    return '';
  };

  private onDeleteClick = () => {
    const { categoryName, deviceType, subtitle } = this.props;

    const page = {
      pageType: trackingPageType,
      siteType: serializeDeviceType(deviceType),
    };

    const options = {
      label: serializeLabel({ categoryName, subtitle }),
      page,
    };

    this.deleteSubscription();
    trackSubscriptionDelete(options);
  };

  private onToggleClick = (params: ISubscriptionIsActiveParams) => {
    const { onChange, isActive, categoryName, frequency, deviceType } = this.props;

    const page = {
      pageType: trackingPageType,
      siteType: serializeDeviceType(deviceType),
    };

    const options = {
      isActive,
      label: getToggleLabel({ categoryName, frequency }),
      page,
    };

    trackSubscriptionToggle(options);
    onChange(params);
  };
}
